import { Component, Input } from '@angular/core';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'canvas-admin-truncated-text',
    templateUrl: './truncated-text.component.html',
    styleUrls: ['./truncated-text.component.scss'],
    standalone: false
})
export class TruncatedTextComponent {
  faCircleInfo = faCircleInfo;
  @Input() text = '';
  @Input() customClass = '';
}
